module.exports = __webpack_public_path__ + "xml/kfzteile-com/browserconfig.xml";